import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SistemaPS24 from "@/components/SistemaPS24";
import NeedHelper from "@/components/NeedHelper";
import CalculatorSection from "@/components/CalculatorSection";
import WhatNotSee from "@/components/WhatNotSee";
import Gallery from "@/components/Gallery";
import ServicesGrid from "@/components/ServicesGrid";
import HowWeWork from "@/components/HowWeWork";
import Zones from "@/components/Zones";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import FinalContact from "@/components/FinalContact";
import FloatingActions from "@/components/FloatingActions";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function CalculatorPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pb-24 md:pb-0">
        <Hero />
        <SistemaPS24 />
        <NeedHelper />
        <CalculatorSection />
        <WhatNotSee />
        <Gallery />
        <ServicesGrid />
        <HowWeWork />
        <Zones />
        <FAQ />
        <FinalContact />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingActions />
      <Toaster position="top-right" richColors />
    </div>
  );
}
